<template>
  <div class="cover">
    <div class="multi-spinner-container">
      <div class="multi-spinner">
        <div class="multi-spinner">
          <div class="multi-spinner">
            <div class="multi-spinner">
              <div class="multi-spinner">
                <div class="multi-spinner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.cover {
  z-index: 10000;
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100vh;
  background-color: #00000073;
  top: 0px;
  left: 0px;

  .multi-spinner-container {
    width: 150px;
    height: 150px;
    position: relative;
    margin: auto;
    overflow: hidden;
  }

  .multi-spinner {
    position: absolute;
    width: calc(100% - 9.9px);
    height: calc(100% - 9.9px);
    border: 5px solid transparent;
    border-top-color:#23b6bc;
    border-radius: 50%;
    box-sizing: content-box;
    -webkit-animation: spin 5s cubic-bezier(0.17, 0.49, 0.96, 0.76) infinite;
    animation: spin 5s cubic-bezier(0.17, 0.49, 0.96, 0.76) infinite;
  }

  @-webkit-keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
